import React, { useEffect } from "react";
import { connect } from "react-redux";
import ScrollIntoView from "../../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../../shared/loader";
import {
  fetchCostumeOverview,
  aliasCostume,
  unaliasCostume,
  deleteMultipleCostumes
} from "./ducks/actions";
import Overview from "./overview";

const OverviewContainer = (props) => {
  const filmId = props.match.params.filmId;
  const {
    fetchCostumeOverview,
    overview,
    loading,
    errors,
    warnings,
    aliasCostume,
    unaliasCostume,
    onboardingSteps,
    processingCostumeIds,
    deleteMultipleCostumes,
    readOnly
  } = props;

  useEffect(() => {
    fetchCostumeOverview(filmId);
  }, [filmId, fetchCostumeOverview]);

  function renderOverview(overview) {
    const totalQuantity = overview.costumes?.length;
    const totalQuantityAcquired = overview.costumes?.filter(c => c.acquired).length || 0;

    const costumesAcquiredPercentage =
      !totalQuantity
        ? 0
        : (totalQuantityAcquired / totalQuantity) * 100;

    return (
      <ScrollIntoView
        className="blade-content wider"
        path="/films/:filmId/costumes/overview"
        loading={loading}>
        <h2 className="menu-label">Overview</h2>
        <Overview
          overview={overview}
          filmId={filmId}
          errors={errors}
          warnings={warnings}
          aliasCostume={aliasCostume}
          unaliasCostume={unaliasCostume}
          costumesAcquiredPercentage={costumesAcquiredPercentage}
          onboardingSteps={onboardingSteps}
          processingCostumeIds={processingCostumeIds}
          deleteMultipleCostumes={deleteMultipleCostumes}
          readOnly={readOnly}
        ></Overview>
      </ScrollIntoView>
    );
  }

  return (
    <>
      {(loading || !overview) && <Loader />}
      {!loading && overview && renderOverview(overview)}
    </>
  );
};

function mapStateToProps(state) {
  const { errors, warnings, overview, loading, onboardingSteps, processingCostumeIds, readOnly } =
    state.costumesOverviewState;
  return {
    errors,
    warnings,
    overview,
    loading,
    onboardingSteps,
    processingCostumeIds,
    readOnly
  };
}

export default connect(mapStateToProps, {
  fetchCostumeOverview,
  aliasCostume,
  unaliasCostume,
  deleteMultipleCostumes
})(OverviewContainer);
